/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Input, Pagination, PaginationItem, PaginationLink, Table } from "reactstrap";
import { IPrompt, promptsService } from "../../../services/prompts";
import { PromptsContainer } from "./styled";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Typography } from "antd";
import { RiDeleteBinLine, RiPencilLine } from "@remixicon/react";
import { ConfirmDeleteModal } from "../../Modals/ConfirmDeleteModal";
import { toast } from "react-toastify";

interface PromptsTableProps {
  prompts: IPrompt[];
  setPrompts: React.Dispatch<React.SetStateAction<IPrompt[]>>;
  setDirt: React.Dispatch<React.SetStateAction<boolean>>;
  projectId: number | string;
  isEditing: boolean;
  isOwner: boolean;
}

export function PromptsTable({
  prompts,
  setPrompts,
  projectId,
  isEditing,
  setDirt,
  isOwner,
}: PromptsTableProps) {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPromptId, setCurrentPromptId] = useState<number | null>(null);

  const MAX_PROMPTS_TO_PAGINATE = 4;
  const totalPages = Math.ceil(prompts.length / MAX_PROMPTS_TO_PAGINATE);

  const displayedPrompts = prompts.slice(
    (currentPage - 1) * MAX_PROMPTS_TO_PAGINATE,
    currentPage * MAX_PROMPTS_TO_PAGINATE,
  );

  function handlePageChange(event: React.MouseEvent, page: number) {
    event.stopPropagation();
    event.preventDefault();
    setCurrentPage(page);
  }

  const handleConfirmDelete = async () => {
    setOpenDeleteModal(false);
    try {
      removeFromPrompts(currentPromptId as number);
      await promptsService.remove(currentPromptId as number);
    } catch (error) {
      toast(t("Toast.deletePrompt"), {
        toastId: "error1",
        position: "top-right",
        autoClose: 5000,
        className: "bg-danger text-white",
        icon: <RiDeleteBinLine />,
      });
    }
  };

  const removeFromPrompts = (id: number) => {
    const newPrompts = prompts.filter((prompt) => prompt.id !== id);
    setPrompts(newPrompts);
  };

  const handleDeletePrompt = (id: number) => {
    setCurrentPromptId(id);
    setOpenDeleteModal(true);
  };

  return (
    <>
      <ConfirmDeleteModal
        isOpen={openDeleteModal}
        toggle={() => setOpenDeleteModal(false)}
        message="Tem certeza de que deseja excluir este prompt?"
        onConfirm={handleConfirmDelete}
        onCancel={() => setOpenDeleteModal(false)}
      />
      <PromptsContainer>
        <Table className="align-middle table-nowrap mb-0" responsiveTag="div" responsive>
          <thead className="table-light">
            <tr>
              <th scope="col" style={{ width: "80%" }}>
                {t("pages.projects.components.createEditPage.prompts.table.prompt")}
              </th>
              <th scope="col" style={{ width: "20%" }}>
                {t("pages.projects.components.createEditPage.prompts.table.action")}
              </th>
            </tr>
          </thead>
          <tbody>
            {displayedPrompts.map((grantedObj) => (
              <tr key={grantedObj.id}>
                <td>
                  <Typography>{grantedObj.title}</Typography>
                  <Typography className="text-muted">{grantedObj.prompt}</Typography>
                </td>
                <td>
                  <Button
                    type="button"
                    color="link"
                    onClick={() => handleDeletePrompt(grantedObj.id)}
                  >
                    <RiDeleteBinLine className="text-muted" />
                  </Button>
                  {/* <Button type="button" color="link">
                  <RiPencilLine className="text-muted" />
                </Button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {prompts.length > MAX_PROMPTS_TO_PAGINATE && (
          <div className="pagination-container">
            <Pagination size="md">
              <PaginationItem disabled={currentPage === 1}>
                <PaginationLink
                  href="#"
                  previous
                  onClick={(e) => handlePageChange(e, currentPage - 1)}
                >
                  {t("global.previousBtn")}
                </PaginationLink>
              </PaginationItem>
              {Array.from({ length: totalPages }).map((_, index) => (
                <PaginationItem active={index + 1 === currentPage} key={index}>
                  <PaginationLink href="#" onClick={(e) => handlePageChange(e, index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={currentPage === totalPages}>
                <PaginationLink next href="#" onClick={(e) => handlePageChange(e, currentPage + 1)}>
                  {t("global.nextBtn")}
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          </div>
        )}
      </PromptsContainer>
    </>
  );
}
